import {useMutation, useQueryClient} from '@tanstack/react-query'

import {deployProjectEquipment} from './api'
import {invalidateEquipmentMoves} from './invalidate-equipment-moves'
import type {DeployProjectEquipmentInput} from './schemas'

export function useDeployProjectEquipment(projectId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: DeployProjectEquipmentInput) =>
            deployProjectEquipment(projectId, input),
        onSuccess: () => invalidateEquipmentMoves(queryClient, projectId),
    })
}
